<template>
    <section class="page-content">
        <div class="user-form-box">
            <div class="form-error" v-if="formError">{{ formError }}</div>
            <div style="    text-align: center;
    color: #00A8CA;" v-if="passwordResetMessage">{{ 'Record updated successfully!' }}
            </div>
            <div class="small-box">
                <md-field :md-toggle-password="false">
                    <label>Old Password</label>
                    <md-input v-model="oldPass" @blur="touchHanlder('oldPass')" type="password"></md-input>
                    <md-tooltip md-direction="right">Enter your current password</md-tooltip>
                </md-field>
                <div class="user-edit-error" v-if="$v.oldPass.$error">Please enter your current password.</div>
                <md-field :md-toggle-password="false">
                    <label>New Password</label>
                    <md-input v-model="newPass" @blur="touchHanlder('newPass')" type="password"></md-input>
                    <md-tooltip md-direction="right">
                        Minimum 8 characters, Maximum 50, 1 uppercase, 1 lowercase, 1 number, and 1 special character
                    </md-tooltip>
                </md-field>
                <div class="user-edit-error" v-if="$v.newPass.$error">
                    Please enter a valid password (Minimum 8 characters, Maximum 50, 1 uppercase, 1 lowercase, 1 number, and 1 special character).
                </div>
                <md-field :md-toggle-password="false">
                    <label>Confirm Password</label>
                    <md-input v-model="confirmPass" @blur="touchHanlder('confirmPass')" type="password"></md-input>
                    <md-tooltip md-direction="right">Confirmation must match your new password</md-tooltip>
                </md-field>
                <div class="user-edit-error" v-if="$v.confirmPass.$error">Please re-enter your new password (must match your new password).</div>
                <md-button v-if="!$v.$invalid" class="md-raised md-primary" @click="updatePassword()">Change Password</md-button>
            </div>
        </div>
    </section>
</template>
<script>
import {mapGetters} from 'vuex';
import {required, minLength} from 'vuelidate/lib/validators';
import {updateUser} from '../../services/UserService.js';
import {validPassword, notWhitespace} from '../../includes/validations.js';

function newPassConfirmed (value) {
  return value === this.newPass;
}

function uniqueNewPass (value) {
  return value !== this.oldPass;
}

export default {
  data: () => ({
    oldPass: '',
    newPass: '',
    confirmPass: '',
    formError: null,
    passwordResetMessage: false
  }),
  computed: {
    ...mapGetters('user', ['initialUser'])
  },
  methods: {
    touchHanlder (key) {
      if (!this.$v[key].$dirty) {
        this.$v[key].$touch();
      }
    },
    async updatePassword () {
      let user = this.initialUser;
      user.oldPass = this.oldPass;
      user.newPass = this.newPass;
      await updateUser(user)
        .then(response => {
          this.oldPass = '';
          this.newPass = '';
          this.confirmPass = '';
          this.formError = null;
          this.$v.$reset();
          this.passwordResetMessage = true;
          setTimeout(() => {
            this.passwordResetMessage = false;
          }, 4000);
        })
        .catch(error => {
          if (error.response.data.type === 'INCORRECT_PASS') {
            this.formError = error.response.data.message;
          }
        });
    }
  },
  validations: {
    oldPass: {
      required,
      notWhitespace

    },
    newPass: {
      required,
      notWhitespace,
      minLength: minLength(8),
      uniqueNewPass,
      validPassword
    },
    confirmPass: {
      required,
      notWhitespace,
      newPassConfirmed
    }
  }
};
</script>
<style lang="scss" scoped>
.edit-user .wrap {
    margin: 0 !important;
}

.form-error {
    font-size: 15px;
    color: red;
}

.user-edit-error {
    margin-top: -20px;
    font-size: 11px;
    color: red;
}

.small-box {
    margin-top: 40px;
    margin-left: 10%;
    width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/EditUserPassword.vue